import moment from 'moment';
import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {Epsonfont} from '@/assets/fonts/Epson1-normal'
import {Epsonfontbold} from '@/assets/fonts/Epson1-bold'

var document_headerCustomFormat = {
  async print(endPoint, docId, isDefaultPrint, customFont){
    // get document_header
    let component_x = {}
    component_x.endPoint = endPoint
    const document_header = await HTTPRequest.getRequest(component_x.endPoint + "documents/" + docId, null);

    // init header values
    let requestingSiteName = document_header.site_id.label;
    let requestingSiteId = document_header.site_id.key;
    let supplier = document_header.supplier_id;
    let documentNumber = document_header.document_no || ''
    let documentDate = moment(document_header.document_date).format('MM/DD/YYYY') || ''
    let printDate = moment().format('lll') || '';
    let postDate = ""
    if (document_header.posted_at != null){
      postDate = document_header.posted_at;
    }
    let reference = document_header.reference || '';
    let remark = document_header.remark || ''
    let createdBy = document_header.created_by_full_name || document_header.created_by || '';
    let postedBy = document_header.posted_by || '';

    let userCode = secureStorage.getItem("userCode") || '';

    // get details
    let document_lines = await HTTPRequest.getRequest(component_x.endPoint + "document_lines/" + docId + "?field_name=document_id&sort=line_no", null);

    // get data
    let siteData = await HTTPRequest.getRequest(`${component_x.endPoint}sites/${requestingSiteId}` , null, null);
    let supplierData = await HTTPRequest.getRequest(`${component_x.endPoint}suppliers/${supplier.key}`, null, null);

    // --- Access Cost / Price masking (Access Cost module = system_module_id 123) ---
    // 'Z' = access to cost values, 'Y' = access to price values.
    let accessCostPriceRights = []
    try {
      let accessCostPriceRightsRequest = await HTTPRequest.getRequest(component_x.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
      if (accessCostPriceRightsRequest && accessCostPriceRightsRequest.access_rights && accessCostPriceRightsRequest.access_rights[123]) {
        accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
      }
    } catch (e) {
      accessCostPriceRights = []
    }

    // Determine the document's price/cost choice to apply the same gating the app uses elsewhere.
    let productPriceChoice = 'landed_cost'
    try {
      if (document_header.document_type_id) {
        let docTypeSettings = await HTTPRequest.getRequest(component_x.endPoint + '/document_types/get_document_type_settings?id=' + document_header.document_type_id, null)
        if (docTypeSettings && docTypeSettings.document_type_settings && docTypeSettings.document_type_settings.priceOrCost) {
          productPriceChoice = String(docTypeSettings.document_type_settings.priceOrCost)
            .replace(/\s+/g, '_')
            .replace(/([a-z])([A-Z])/g, '$1_$2')
            .toLowerCase()
        }
      }
    } catch (e) {
      productPriceChoice = 'landed_cost'
    }

    let noZ = !accessCostPriceRights.includes('Z')
    let noY = !accessCostPriceRights.includes('Y')
    // This Delivery Receipt shows RETAIL PRICE / TOTAL AMOUNT columns (price-based),
    // so the price right ('Y') gates them; also honor the cost/price-choice rule.
    let hidePrice = noY
    let hideSubtotal = (noZ && (productPriceChoice == 'landed_cost' || productPriceChoice == 'ordering_cost' || productPriceChoice == 'original_cost')) ||
                       (noY && (productPriceChoice == 'retail_price' || productPriceChoice == 'wholesale_price'))
    let maskValue = '***'

    // load account settings
    component_x.printFontSizeIncrease = 0
    let AccountSettings = await HTTPRequest.getRequest(component_x.endPoint + 'settings?code=accountSettings&status=A', null)
    if(AccountSettings.length > 0){
      let as = JSON.parse(AccountSettings[0].value)
      let printFontSize = as.printSettingsFontSizePTPM
      if(printFontSize != null){
        component_x.printFontSizeIncrease = printFontSize
      }
    }
    let fontSizeIncreaser = component_x.printFontSizeIncrease || 0

    // need to replace later on based on db save.
    const paperSize = "a4"
    const orientation = 'portrait'
    let doc = new jsPDF({ orientation: orientation, unit: 'mm', format: paperSize });

    // add dot matrix font
    doc.addFileToVFS('Epson1-normal.ttf', Epsonfont);
    doc.addFont('Epson1-normal.ttf', 'Epson1', 'normal');
    doc.addFileToVFS('Epson1-bold.ttf', Epsonfontbold);
    doc.addFont('Epson1-bold.ttf', 'Epson1', 'bold');

    // declare header style
    let hdStyles = {
      lineWidth: 0.15,
      cellPadding: 2,
      fontSize: 8 + fontSizeIncreaser,
      fontStyle: 'bold'
    }

    // declare style
    let styles = {
      fontSize: 7 + fontSizeIncreaser
    }

    // make a dynamic column width based on number of columns
    let default_column_no = 6
    let max_table_width = 180 // if portrait
    let col_width = max_table_width / default_column_no // column equal width

    let headerCustomPosition = 0

    if(customFont == 'dotMatrix'){
      doc.setFont("Epson1");
      hdStyles.font = 'Epson1';
      styles.font = 'Epson1';
      headerCustomPosition = -10;
    }

    // === HEADER SECTION ===

    // Logo + Company Name
    let logobarter = document.getElementById('logobarter');
    doc.addImage(logobarter, "PNG", 15, 15, 25, 25);
    doc.setFontStyle("bold");
    doc.setFontSize(16 + fontSizeIncreaser);
    doc.text("GOLDWING RETAIL GROUP, INC.", 105, 25, { align: 'center' });

    // Company address
    doc.setFontStyle("normal");
    doc.setFontSize(9 + fontSizeIncreaser);
    const companyAddress = siteData.company_address || '#61 F. Balagtas St. Marikina Philippines';
    const addressSplit = doc.splitTextToSize(companyAddress, 130);
    doc.text(addressSplit, 105, 32, { align: 'center' });

    // Document Title - DELIVERY RECEIPT
    doc.setFontStyle("bold");
    doc.setFontSize(14 + fontSizeIncreaser);
    doc.text("DELIVERY RECEIPT", 105, 50, { align: 'center' });

    // Left side fields
    let leftLabelX = 15
    let leftValueX = 45
    let rightLabelX = 140 + headerCustomPosition
    let rightValueX = 170 + headerCustomPosition

    doc.setFontStyle("bold");
    doc.setFontSize(10 + fontSizeIncreaser);

    // COMPANY
    doc.text("COMPANY:", leftLabelX, 62);
    doc.setFontStyle("normal");
    const customerName = (document_header.target_site_id && document_header.target_site_id.label) || '';
    doc.text(customerName, leftValueX, 62);

    // SHIP VIA
    doc.setFontStyle("bold");
    doc.text("SHIP VIA:", leftLabelX, 69);
    doc.setFontStyle("normal");
    const shipVia = reference || '';
    const shipViaSplit = doc.splitTextToSize(shipVia, 80);
    doc.text(shipViaSplit, leftValueX, 69);

    // BRAND
    doc.setFontStyle("bold");
    doc.text("BRAND:", leftLabelX, 80);
    doc.setFontStyle("normal");
    const brand = remark || '';
    doc.text(brand, leftValueX, 80);

    // Right side fields
    doc.setFontStyle("bold");
    doc.setFontSize(10 + fontSizeIncreaser);

    // D.R. NO.
    doc.text("D.R. NO.  :", rightLabelX, 62);
    doc.setFontStyle("normal");
    doc.text(String(documentNumber), rightValueX, 62);

    // D.R. DATE
    doc.setFontStyle("bold");
    doc.text("D.R. DATE :", rightLabelX, 69);
    doc.setFontStyle("normal");
    doc.text(documentDate, rightValueX, 69);

    // === TABLE SECTION ===
    let headers = [];
    let headers_tmp = [];

    headers_tmp.push(
      {content: 'SKU', styles: {halign: 'center', valign: 'middle'}},
      {content: 'STYLE CODE', styles: {halign: 'center', valign: 'middle'}},
      {content: 'DESCRIPTION / COLOR', styles: {halign: 'center', valign: 'middle'}},
      {content: 'QTY', styles: {halign: 'center', valign: 'middle'}},
      {content: 'RETAIL PRICE', styles: {halign: 'center', valign: 'middle'}},
      {content: 'TOTAL AMOUNT', styles: {halign: 'center', valign: 'middle'}}
    );

    headers.push(headers_tmp)

    // column styles
    let colStyles = {
      0: { halign: 'center', cellWidth: 25 },  // SKU
      1: { halign: 'center', cellWidth: 30 },  // STYLE CODE
      2: { halign: 'center', cellWidth: 55 },     // DESCRIPTION / COLOR
      3: { halign: 'center', cellWidth: 20 },   // QTY
      4: { halign: 'right', cellWidth: 25 },    // UNIT PRICE
      5: { halign: 'right', cellWidth: 30 }     // TOTAL AMOUNT
    }

    // body (table)
    let reportData = []
    let detail = []
    let reportLine = {}

    let grand_qty = 0
    let grand_ext = 0
    let grand_cost = 0
    let grand_discount = 0
    let grand_tax = 0
    let grand_net = 0

    for(let i=0; i < document_lines.length; i++){
      reportLine = document_lines[i]

      grand_qty = grand_qty + Number(reportLine.quantity)
      grand_ext = grand_ext + Number(reportLine.subtotal)
      grand_cost = grand_cost + Number(reportLine.cost || 0)
      grand_discount = grand_discount + Number(reportLine.discount || 0)
      grand_tax = grand_tax + Number(reportLine.tax_amount || 0)
      grand_net = grand_net + Number(reportLine.subtotal_without_vat || 0)

      let descriptionColor = reportLine.short_name || ''

      detail = [
        reportLine.erp_code || '',
        reportLine.design_code || '',
        descriptionColor,
        this.convertToCurrency(Number(reportLine.quantity), 0),
        hidePrice ? maskValue : this.convertToCurrency(Number(reportLine.price), 2),
        hideSubtotal ? maskValue : this.convertToCurrency(Number(reportLine.subtotal), 2)
      ];

      reportData.push(Object.assign({}, detail))
    }

    // initial position of table
    let startY = 88

    doc.autoTable({
      startY: startY,
      head: headers,
      body: reportData,
      theme: 'grid',
      tableWidth: 'wrap',
      styles: styles,
      headStyles: hdStyles,
      columnStyles: colStyles,
      margin: { left: 15, bottom: 40 },
      didParseCell: function(data) {
        if (data.row.section == 'head'){
          data.cell.styles.fillColor = [255, 255, 255]
          data.cell.styles.textColor = [0, 0, 0]
          data.cell.styles.lineColor = [0, 0, 0]
        }
        if (data.row.section == 'body'){
          data.cell.styles.lineColor = [0, 0, 0]
        }
      }
    });

    let finalY = doc.lastAutoTable.finalY;

    // === FOOTER ===
    let dynamic_y = finalY + 18

    // Prepared by row with totals
    dynamic_y = dynamic_y + 10
    doc.setFontStyle("bold");
    doc.setFontSize(9 + fontSizeIncreaser);
    doc.text("Prepared by :", 15, dynamic_y);
    doc.line(40, dynamic_y + 1, 100, dynamic_y + 1);
    doc.text(createdBy, 70, dynamic_y, { align: 'center' });

    doc.text("TOTAL :", 105, dynamic_y);
    doc.text(this.convertToCurrency(Number(grand_qty), 0), 135, dynamic_y);
    doc.text(hideSubtotal ? maskValue : this.convertToCurrency(Number(grand_ext), 2), 195, dynamic_y, { align: 'right' });

    // Received by row
    dynamic_y = dynamic_y + 10
    doc.text("Received by :", 15, dynamic_y);
    doc.line(40, dynamic_y + 1, 100, dynamic_y + 1);

    // Page numbers on each page - at bottom of paper
    let pageCount = doc.internal.getNumberOfPages();
    for(let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8 + fontSizeIncreaser);
        doc.setFontStyle("bold");
        doc.text(`PAGE ${String(i)} OF ${String(pageCount)}`, 105, 290, { align: 'center' });
    }

    window.open(URL.createObjectURL(doc.output("blob")))
  },
  convertToCurrency(num, scale){
    return num.toFixed(scale).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  },
}

export default document_headerCustomFormat;
